import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {adminStrategies, adminStrategy, adminUpdateStrategy, adminDeleteStrategy} from '../../services/apiService'

export const adminStrategiesSlice = createSlice({
    name: 'adminStrategies',
    initialState: {
        loading : false,
        strategies: [],
        pagination : {
            showSizeChanger:false,
            total: 0,
            pageSize: 20,
            current: 0
        },
        tableFilters: undefined,
        filters: undefined,
        editedStrategy: {},
        visibleDialog: false
    },
    reducers: {
        setVisibleDialog: (state, action) => {
            state.visibleDialog = action.payload;
        },
        clearEditedStrategyData: (state) => {
            state.editedStrategy = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadAdminStrategies.pending, (state, action) => {
                // const {tableFilters, pagination } = action.meta.arg;
                state.loading = true;
                // state.tableFilters = tableFilters;
                // state.pagination = pagination;
            })
            .addCase(loadAdminStrategies.fulfilled, (state, action) => {
                const {content: strategies = [], pageable: page, totalElements} = action.payload;
                const pagination = {
                    total: totalElements,
                    pageSize: page.pageSize,
                    current: page.pageNumber + 1
                };
                state.strategies = strategies;
                state.pagination = pagination;
                state.loading = false;
            })
            .addCase(loadAdminStrategies.rejected, (state, action) => {
                state.strategies = [];
                state.loading = false;
            })
            .addCase(getStrategy.fulfilled, (state, action) => {
                state.editedStrategy = action.payload;
            })
            .addCase(getStrategy.rejected, (state) => {
                state.editedStrategy = {};
            })
            .addCase(updateStrategy.fulfilled, (state, action) => {
                const updatedStrategy = action.payload;
                const existingIndex = state.strategies.findIndex(
                    strategy => strategy.code === updatedStrategy.code
                );

                if (existingIndex >= 0) {
                    state.strategies[existingIndex] = updatedStrategy;
                } else {
                    state.strategies.unshift(updatedStrategy);
                    if (state.pagination) {
                        state.pagination.total += 1;
                    }
                }
            })
            .addCase(deleteStrategy.fulfilled, (state, action) => {
                const deletedCode = action.meta.arg;

                state.strategies = state.strategies.filter(
                    strategy => strategy.code !== deletedCode
                );

                if (state.pagination) {
                    state.pagination.total = Math.max(0, state.pagination.total - 1);
                }
            })
    }
})

export const { setVisibleDialog, clearEditedStrategyData } = adminStrategiesSlice.actions;

export const loadAdminStrategies = createAsyncThunk('adminStrategies/loadAdminStrategies', ({pagination, sorting}) => {
    return adminStrategies(pagination, sorting);
})

export const updateStrategy = createAsyncThunk('adminStrategies/updateStrategy', (values) => {
    return adminUpdateStrategy(values);
})

export const deleteStrategy = createAsyncThunk('adminStrategies/deleteStrategy', (code) => {
    return adminDeleteStrategy(code);
})

export const getStrategy = createAsyncThunk( 'adminStrategies/getStrategy', (code) => {
    return adminStrategy(code);
});

export default adminStrategiesSlice.reducer

